(function () {
  function setDeleteButtonState(button, isLoading) {
    if (!button) {
      return;
    }

    if (isLoading) {
      button.dataset.deleting = "true";
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.setAttribute("aria-disabled", "true");
      return;
    }

    button.dataset.deleting = "false";
    button.disabled = false;
    button.removeAttribute("aria-busy");
    button.removeAttribute("aria-disabled");
  }

  async function getShopifyCartId() {
    const cookieMatch = `; ${document.cookie}`.match(/;\s*cart=([^;]+)/);
    if (cookieMatch) {
      return cookieMatch[1].slice(-10);
    }

    const response = await fetch("/cart.js", {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("Could not load the current cart");
    }

    const cart = await response.json();
    return cart.token ? cart.token.slice(-10) : null;
  }

  async function parseJsonResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { error: text };
    }
  }

  function cartLineKeysFor(button) {
    const keys = [
      button.dataset.lineItemKey,
      button.dataset.backstoryLineKey,
    ].filter(Boolean);

    return Array.from(new Set(keys));
  }

  async function removeCartLinesByKey(lineItemKeys) {
    const updates = {};
    lineItemKeys.forEach((lineItemKey) => {
      updates[lineItemKey] = 0;
    });

    const response = await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ updates }),
    });

    const payload = await parseJsonResponse(response);

    if (!response.ok) {
      throw new Error(payload.description || payload.error || "Could not remove this item from your cart");
    }
  }

  async function removeCartLines(button) {
    const lineItemKeys = cartLineKeysFor(button);

    if (!lineItemKeys.length) {
      throw new Error("Could not determine which cart line to remove");
    }

    await removeCartLinesByKey(lineItemKeys);
  }

  async function deleteFramefoxProductable(button) {
    if (!button || button.dataset.deleting === "true") {
      return;
    }

    const draftOrderItemId = button.dataset.draftOrderItemId;
    if (!draftOrderItemId) {
      return;
    }

    const pill = button.querySelector(".cart-action-pill");
    const originalLabel = pill ? pill.textContent : null;

    setDeleteButtonState(button, true);

    if (pill) {
      pill.textContent = "Deleting";
    }

    try {
      const shopifyCartId = await getShopifyCartId();

      if (!shopifyCartId) {
        throw new Error("Could not determine the current Shopify cart");
      }

      await removeCartLines(button);

      try {
        const softDeleteResponse = await fetch(`/apps/frame/draft_order_items/${draftOrderItemId}/soft_delete`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            shopify_cart_id: shopifyCartId,
          }),
        });

        const softDeletePayload = await parseJsonResponse(softDeleteResponse);

        if (!softDeleteResponse.ok) {
          throw new Error(softDeletePayload.error || "Could not delete this item");
        }
      } catch (softDeleteError) {
        console.warn("Framefox proxy soft delete failed after Shopify cart lines were removed.", softDeleteError);
      }

      window.location.reload();
    } catch (error) {
      console.error("Error deleting Framefox cart item:", error);
      alert(error.message || "Failed to delete item. Please try again.");
    } finally {
      setDeleteButtonState(button, false);

      if (pill && originalLabel) {
        pill.textContent = originalLabel;
      }
    }
  }

  window.deleteFramefoxProductable = deleteFramefoxProductable;
})();
